//  <FileHeader xmlns="http://www.gordic.cz/shared/file-header/v_1.0.0.0">
//    <Name>        Gordic.Adm.WebControls.SeznamOrganizacniJednotkaDesigner.ts             </Name>
//    <Description>                                                             </Description>
//    <Author>      FFIALA                                                      </Author>
//    <Copyright>   � GORDIC spol. s r. o. 1993-2020                            </Copyright>
//    <Created>     2020-08-12                      </Created>
//  </FileHeader>

//This source code was auto-generated by ADT03-Generator, Version=484.76.1
//AdtGeneratorConfig:[ T:(ginsorj) GID:(Web.Set.Des.Ts) V1:(ixs_orj,poznamka,dat_od,dat_do,dat_zmena,zkratka,nazev,ixs_nad,ofic_nazev) V2:(aktivita,zmenu_prov) K1:() K2:() ]


/// <reference path="../../Base/SeznamBase.ts" />

namespace Gordic.Adm.WebControls {

    /**
     * SeznamOrganizacniJednotkaDesigner
     * 
     * @author FFIALA
     * @since 482.1.0.119
     */
    export class SeznamOrganizacniJednotkaDesigner extends SeznamBase {

        /** z detail okna p�edan� atribut pro filtr seznamu */
        /** PK - ixs_orj */
        public ixs_orj: string;

        /** isl view gridu */
        view: Gordic.Isl.View<Gordic.AdmIsl.Interface.GOrganizacniJednotkaListDto>;

        /** vytvo�it formul�� filtru - panel */
        static createFilter(that: GContentType<SeznamOrganizacniJednotkaDesigner>): JQuery<HTMLElement> {
            // vytvorim form a na nem policka
            let v_form = this.createFilterForm(that);
            // vytvorim panel a umistim jej do hlavniho DIVu
            let v_filter = SeznamBase.createFilterBase(that, v_form, true);

            //v_filter.gfilterpanel("applyFilter");         // toto vede k okam�it�mu na�ten� dat do seznamu podle nastaven�ho filtru

            return (v_filter);
        } // createFilter

        /** vytvo�it formul�� filtru - vytvo�� tam filtra�n� pol��ka */
        static createFilterForm(that: GContentType<SeznamOrganizacniJednotkaDesigner>): Forms.Form {

            // vytvo��m form
            var v_filterForm = this.createFilterFormBase(that);

            // p�id�m do n�j pol��ka

            return v_filterForm;
        } // createFilterForm

        /**
         * SeznamOrganizacniJednotkaDesignerInit
         * 
         * @param {GContentType<SeznamOrganizacniJednotkaDesigner>} that
         */
        static SeznamOrganizacniJednotkaDesignerInit(that: GContentType<SeznamOrganizacniJednotkaDesigner> ) {

            //SeznamBase.SeznamBaseInit(that as GContentType<SeznamBase>);

            this.SeznamBaseInit(that);
            that.filter = this.createFilter(that);

            //that.gridFormat = this.createGridFormatByDataListDescription(that, dataListDescription);
            that.gridFormat = this.createGridFormatByDataListDescription(that );
            //that.gridSearchColumns = this.createGridSearchColumnsByDataListDescription(that, dataListDescription);
            that.gridSearchColumns = this.createGridSearchColumnsByDataListDescription(that );

            that.view = new Gordic.Isl.View(that.isl.OrganizacniJednotka.list(), { filterPanel: that.filter, startEmpty: false, });       // propojen� ovl�dac�ho prvku gridu se zdrojem dat - a s filter panelem

            // test funkce jin�ho ISL listu
            //that.view = new Gordic.Isl.View(that.isl.AdmObjektZmena.list(), { filterPanel: that.filter, startEmpty: false, });       // propojen� ovl�dac�ho prvku gridu se zdrojem dat - a s filter panelem

        } // SeznamOrganizacniJednotkaDesignerInit

    }
}
